import { genderFormat, cashCount, strReplace } from '@/utils/formUtils'
import timeutils from 'utils/wt-time-utils'
import { recordTypes, identityCardType, milestoneTypes, businessTypesWallet, couponStatus, sampleTypes, sampleSubTypes, levelChangeTypeOptions, customerReportTypes } from 'json/customer-options'
import { getEnumeration } from 'enumeration'
import { getDiscountType, getPublishType, getCouponStatus } from 'enumeration/mall.js'
import mallDatas from './mall'
export default {
// 获取用户列表数据处理
  getMallUser (data, businessSourceList) {
    data.forEach(item => {
      let businessInformation = item.businessInformation || {}
      item.gender = item.gender && genderFormat(item.gender)
      item.birthday_date = item.birthday && timeutils.format(item.birthday, 'date')
      item.is_registry = item.registry ? '是' : '否'
      item.last_login_time = item.lastLoginTime && timeutils.format(item.lastLoginTime)
      item.invited_time = item.invitationTime && timeutils.format(item.invitationTime, 'date')
      item.sourceName = businessInformation.source && getEnumeration(businessInformation.source, businessSourceList, 'name')
      item.isCPS = item.labels && item.labels.CPS ? '是' : '否'
      item.registry_time = item.registryTime && timeutils.format(item.registryTime)
      item.isFamily = item.labels && item.labels.FAMILY_MEMBER ? '是' : '否'
      item.family_date = item.familyDate && timeutils.format(item.familyDate)
      item.levelChangeTime_date = item.levelChangeTime && timeutils.format(item.levelChangeTime)
      item.levelName_name = item.levelName + '会员'
    })
    return data
  },
  mallUserDetail (data, businessSourceList) {
    let businessInformation = data.businessInformation || {}
    data.sex = data.gender && genderFormat(data.gender)
    data.idCardType = data.identityCardType && getEnumeration(data.identityCardType, identityCardType)
    data.birthday_date = data.birthday && timeutils.format(data.birthday, 'date')
    data.sourceName = businessInformation.source && getEnumeration(businessInformation.source, businessSourceList, 'name')
    data.isCPS = data.labels && data.labels.CPS ? '是' : '否'
    data.is_registry = data.registry ? '是' : '否'
    let shippingAddresses = data.shippingAddresses || []
    shippingAddresses.forEach(item => {
      item.address = (item.provinceName ? item.provinceName : '') + (item.cityName ? item.cityName : '') + (item.districtName ? item.districtName : '') + (item.postAddress ? item.postAddress : '')
    })
    data.registry_time = data.registryTime && timeutils.format(data.registryTime)
    data.isFamily = data.labels && data.labels.FAMILY_MEMBER ? '是' : '否'
    data.family_date = data.familyDate && timeutils.format(data.familyDate)
    return data
  },
  healthRecords (data) {
    data.forEach(item => {
      item.record_type = item.recordType && getEnumeration(item.recordType, recordTypes)
      item.idCardType = item.identityCardType && getEnumeration(item.identityCardType, identityCardType)
      item.created_date = item.createdDate && timeutils.format(item.createdDate)
    })
    return data
  },
  getUserIntegralList (data) {
    data.forEach(item => {
      item.changeDate = item.createdDate && timeutils.format(item.createdDate)
      item.changeValue = item.changeType === 'INCREASE_POINTS' ? ('+' + item.value) : ('-' + item.value)
    })
    return data
  },
  lifeMilestone (data) {
    data.forEach(item => {
      item.milestone_time = timeutils.format(item.time)
      item.milestone_type = getEnumeration(item.type, milestoneTypes)
    })
    return data
  },
  getHealthRecordDetail (data) {
    data.sex = data.gender && genderFormat(data.gender)
    data.birthday_date = data.birthday && timeutils.format(data.birthday, 'date')
    data.record_type = data.recordType && getEnumeration(data.recordType, recordTypes)
    data.created_date = data.createdDate && timeutils.format(data.createdDate)
    data.idCardType = data.identityCardType && getEnumeration(data.identityCardType, identityCardType)
    return data
  },
  systemCustomerList (data) {
    data.forEach(item => {
      item.sex = item.gender && genderFormat(item.gender)
      item.role_display_name = item.roleDisplayName && item.roleDisplayName.join('/')
    })
    return data
  },
  getOrganizations (data) {
    data.forEach(item => {
      item.displayName = item.fullName || item.name
    })
    return data
  },
  walletAccountDetail (data) {
    data.amount = (data.wallet && data.wallet.balance && cashCount(data.wallet.balance, true, 2)) || 0
    let bankAccount = data.bankAccount || {}
    bankAccount.card_number = bankAccount.cardNumber && strReplace(bankAccount.cardNumber, 4)
    bankAccount.id_card = bankAccount.idCard && strReplace(bankAccount.idCard, 4, 4)
    return data
  },
  walletAccountRecord (data) {
    data.forEach(item => {
      let accountDetail = item.accountDetail || {}
      let withdrawalsLog = item.withdrawalsLog || {}
      let bankAccount = withdrawalsLog.bankAccount || {}
      accountDetail.business_type = accountDetail.businessType && getEnumeration(accountDetail.businessType, businessTypesWallet)
      accountDetail.withdraw_amount = (accountDetail.amount && cashCount(accountDetail.amount, true, 2)) || 0
      withdrawalsLog.card_number = accountDetail.businessType === 'WITHDRAWALS' ? (bankAccount.cardNumber && strReplace(bankAccount.cardNumber, 4)) : null
      accountDetail.transaction_date = accountDetail.date && timeutils.format(accountDetail.date)
    })
    return data
  },
  familyListTable (data) {
    data.forEach(item => {
      item.sex = item.gender && genderFormat(item.gender)
      item.birth_day = item.birthDay && timeutils.format(item.birthDay, 'date')
      item.invitation_day = item.invitationDay && timeutils.format(item.invitationDay)
    })
    return data
  },
  inviteCustomerBringNew (data) {
    data.forEach(item => {
      let newCustomer = item.newCustomer || {}
      let user = newCustomer.user || {}
      item.sex = user.gender && genderFormat(user.gender)
      item.birth_day = user.birthday && timeutils.format(user.birthday, 'date')
      item.created_date = item.createdDate && timeutils.format(item.createdDate, 'date')
    })
    return data
  },
  mallUserCoupons (data) {
    data.forEach(item => {
      item.discount_type = getDiscountType(item.discountType)
      item.discount_show = item.discountType === 'FIXED_AMOUNT' ? '¥' + cashCount(item.discount, true, 2) : cashCount(item.discount, true) + '折'
      item.validity_date = timeutils.format(item.startTime, 'date') + '至' + timeutils.format(item.endTime, 'date')
      item.publishType = getPublishType(item.grantType)
      item.use_status = item.useStatus && getEnumeration(item.useStatus, couponStatus)
      item.threshold_of_amount = item.thresholdOfAmount && cashCount(item.thresholdOfAmount, true)
      if (item.couponStatus === 'ACTIVATED') {
        mallDatas.ACTIVATED_status(item, item)
        setInterval(_ => {
          mallDatas.ACTIVATED_status(item, item)
        }, 5000)
      } else {
        item.coupon_status = getCouponStatus(item.couponStatus)
      }
    })
    return data
  },
  getUserSamples (data) {
    data.forEach(item => {
      let mallSample = item.mallSample || {}
      item.sampleType = getEnumeration(mallSample.type, sampleTypes)
      item.sampleSubType = getEnumeration(mallSample.subType, sampleSubTypes)
      item.createdDate = mallSample.createdDate && timeutils.format(mallSample.createdDate, 'date')
      item.is_visible = item.isVisible ? '已生成报告' : '未生成报告'// 报告状态
      item.isVisibleSample = mallSample.visible ? '可见' : '不可见'// C端是否可见（屏蔽状态的报告，C端不可见）
      if (item.mallSample.cpsReportInformation && item.mallSample.cpsReportInformation.length) {
        item.mallSample.cpsReportInformation.forEach(etem => {
          etem.report_type = getEnumeration(etem.type, customerReportTypes)
          etem.created_date = etem.createDate && timeutils.format(etem.createDate, 'date')
        })
      }
    })
    return data
  },
  getUserContracts (data) {
    data.forEach(item => {
    })
    return data
  },
  customerMemberLevelInfo (data) {
    data.levelChangeTime = timeutils.format(data.levelChangeTime, 'default')
    data.userMemberLevelLogList.forEach(item => {
      item.createdDate = timeutils.format(item.createdDate, 'default')
      item.level_change_type = getEnumeration(item.levelChangeType, levelChangeTypeOptions)
    })
    return data
  },
  getAnnualReport (data, barcode) {
    let newData = data.filter(item => item.barcode === barcode.proBarcode)
    if (newData.length) {
      return newData[0].lst
    }
    return newData
  },
  // 处理存储产品进度
  getStorageProgress (data) {
    let temp = {}
    data.forEach(item => {
      if (item.text === '报告已生成') {
        temp.reportGenerated = item.result ? '是' : '否'
      }
      if (item.text === '质量评价') {
        temp.qualityEvaluation = item.code === 'Y' ? '已通过' : '未通过'
      }
    })
    return temp
  },
  // 处理存储产品进度(新接口)
  getCPSStorageProgress (data) {
    let temp = {}
    data.forEach(item => {
      if (item.text === '报告已生成') {
        temp.reportGenerated = item.passed ? '是' : '否'
      }
      if (item.text === '质量评价') {
        temp.qualityEvaluation = item.passed ? '已通过' : ('未通过' + (item.code ? (' code: ' + item.code) : ''))
      }
    })
    return temp
  }
}
